import moment from 'moment';

const parseRuleDate = value => {
  if (!value) return null;
  const dateOnly = String(value).split('T')[0];
  const parsed = moment(dateOnly, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed : null;
};

const formatRuleDate = value => {
  if (!value) return null;
  if (moment.isMoment(value)) return value.format('YYYY-MM-DD');
  const dateOnly = String(value).split('T')[0];
  const parsed = moment(dateOnly, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
};

export const getInitialValues = (rule = null) => {
  if (!rule) {
    return {
      frequency: 'monthly',
      auto_submit: false,
      active: true,
    };
  }
  return {
    order_type_id: rule.order_type_id,
    frequency: rule.frequency,
    day_of_month: rule.day_of_month,
    month_of_year: rule.month_of_year,
    start_date: parseRuleDate(rule.start_date),
    end_date: parseRuleDate(rule.end_date),
    auto_submit: !!rule.auto_submit,
    active: rule.active !== false,
  };
};

export const prepareFormData = values => {
  return {
    order_type_id: values.order_type_id,
    frequency: values.frequency,
    day_of_month:
      values.frequency === 'monthly' || values.frequency === 'quarterly'
        ? values.day_of_month || null
        : null,
    month_of_year:
      values.frequency === 'yearly' || values.frequency === 'biennial'
        ? values.month_of_year || null
        : null,
    start_date: formatRuleDate(values.start_date),
    end_date: formatRuleDate(values.end_date),
    auto_submit: !!values.auto_submit,
    active: values.active !== false,
  };
};
